import React, { useState } from 'react';

const BugReportModal = ({ close }) => {
  const [subject, setSubject]   = useState('');
  const [details, setDetails]   = useState('');
  const [screenshot, setScreenshot] = useState(null);

  const handleFileChange = e => {
    const file = e.target.files[0];
    setScreenshot(file);
  };

  const handleSubmit = e => {
    e.preventDefault();
    // TODO: upload { subject, details, screenshot } to your bug-report endpoint
    alert(`Bug report sent!\nSubject: ${subject}\nDetails: ${details}\nFile: ${screenshot?.name || 'None'}`);
    close();
  };

  return (
    <div className="modal-overlay" onClick={close}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <button className="modal-close" onClick={close}>×</button>
        <h2>Report a Bug</h2>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            required
            placeholder="Subject"
            value={subject}
            onChange={e => setSubject(e.target.value)}
          />
          <textarea
            required
            rows="4"
            placeholder="What happened? Steps to reproduce..."
            value={details}
            onChange={e => setDetails(e.target.value)}
          />
          <label className="file-upload-label">
            {screenshot ? screenshot.name : 'Upload screenshot (optional)'}
            <input
              type="file"
              accept="image/*"
              onChange={handleFileChange}
            />
          </label>
          <button type="submit" className="btn-primary">Submit</button>
        </form>
      </div>
    </div>
  );
};

export default BugReportModal;
